var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLike = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14L6.84 12.9929C2.72 9.42997 0 7.08011 0 4.19619C0 1.84632 1.936 0 4.4 0C5.792 0 7.128 0.617984 8 1.59455C8.872 0.617984 10.208 0 11.6 0C14.064 0 16 1.84632 16 4.19619C16 7.08011 13.28 9.42997 9.16 13.0005L8 14Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLike);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/like.b83970817ff4740f1a18749e186152a7.svg";